import React from 'react';
import type { AnalyticsAttributes } from './contracts';

/**
 * A component that makes it easier to apply analytics attributes to elements.
 *
 * It is meant to be used in combination with the `useTrackClickEvents` hook
 * from `@carvana/merch-react-hooks`.
 */

type OwnProps<Element> = React.HTMLProps<Element> & {
  'data-analytics-id': string | null;
  'data-analytics-attributes'?: AnalyticsAttributes;
  'data-native-payload'?: Record<string, any>;
  element: string;
};

export default function TrackClick<Element = HTMLElement>({
  'data-analytics-id': analyticsId,
  'data-analytics-attributes': analyticsAttributes,
  'data-native-payload': nativePayload,
  element: Component,
  ...props
}: OwnProps<Element>) {
  return (
    <Component
      data-analytics-id={analyticsId}
      data-analytics-attributes={
        analyticsAttributes ? JSON.stringify(analyticsAttributes) : undefined
      }
      data-native-payload={
        nativePayload ? JSON.stringify(nativePayload) : undefined
      }
      {...props}
    />
  );
}
